import { atom } from 'jotai';
import { CallSummaryProgressState, CallSummaryProgressStatus } from '../typings/ai-call-summary';

export type CallBulkSummaryProgress = {
  chatId: string;
  chatSummaryWeekId?: string;
  progress: number;
  status: CallSummaryProgressStatus;
  state: CallSummaryProgressState;
  processedCount: number;
  totalCalls: number;
};

// Keyed by chatId, then chatSummaryWeekId
export const callBulkSummaryProgressAtom = atom<Record<string, Record<string, CallBulkSummaryProgress>>>({});
